module.exports = __webpack_public_path__ + "img/JoernMeyer2_140x140_rund.afde10d2.jpg";